import styled from 'styled-components/macro';
import { colorCoreGray500 } from '@yme/tokens/colors';
export const ContainerStyled = styled.div `
  margin-top: 32px;
`;
export const RowContainerStyled = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;
export const DividerStyled = styled.div `
  height: 1px;
  background-color: ${colorCoreGray500};
  margin: 14px 0;
`;
